// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#default-layout-content{width:100%;height:calc(100% - 80px)}@media (min-width:768px){#default-layout-content{margin:0 0 0 250px;width:calc(100% - 250px);height:100%;box-shadow:0 2px 7px 0 rgba(0,0,0,.18);background-color:#fafbfc}}", ""]);
// Exports
module.exports = exports;
